import React, { PropTypes } from 'react'
import ReactModal from 'react-modal'
import cx from 'classnames'

import './Modal.scss'

const Modal = (props) => {
  const className = cx(
    'Modal-content',
    {
      [props.className]: props.className
    }
  )

  const overlayClassName = cx(
    'Modal-overlay',
    {
      [props.overlayClassName]: props.overlayClassName
    }
  )

  return (
    <ReactModal {...props} className={className} overlayClassName={overlayClassName}>
      <button className='Modal-closeButton' onClick={props.onRequestClose}>x</button>
      {props.children}
    </ReactModal>
  )
}

Modal.displayName = 'Modal'
Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  contentLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
  overlayClassName: PropTypes.string
}
Modal.defaultProps = {
  contentLabel: 'Modal'
}

export default Modal



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/Modal/Modal.js